// extracted by mini-css-extract-plugin
export default {"note":"chatNote_note__JZVC1","loader":"chatNote_loader__fDXI3","l1":"chatNote_l1__VWisy"};